<template>
    <component :is="component"/>
</template>

<script>

export default {
    components: {
    },
    head() {
        return {
        };
    },
    beforeCreate() {
        this.component = 'desktop';
    },
    async asyncData({
        app, route, store, redirect
    }) {
        if (store.state.device === 'mobile' || app.$device.isIos || app.$device.isTablet || app.$device.isAndroid) {
            try {
                let params;
                let result;
                if (route.name === 'match') {
                    params = {
                        live: this.route.query.live,
                        leagueId: this.route.query.leagueId,
                        matchId: this.route.query.matchId
                    };
                }
                if (route.name === 'the-thao-chau-a' && route.query.ver === 'desktop') {
                    params = {
                        device: route.query.ver
                    };
                }
                if (params) {
                    result = await app.$urlApi.getUrlByName(route.name, params);
                } else {
                    result = await app.$urlApi.getUrlByName(route.name);
                }
                if (result && result.status === 'OK') {
                    if (result.data.maintenance) {
                        redirect('/bao-tri');
                    }
                    const url = result.data.url;
                    redirect(url);
                } else {
                    app.$alertSystemMaintain();
                }
            } catch (error) {
                app.$alertSystemMaintain();
            }
        }
    },
    data() {
        return {
        };
    },
    methods: {
    }
};
</script>
